import React, { useEffect, useState } from "react";
import {
    Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Form, Label, Input,
    Container,
    FormGroup,
    Row,
    Col,
    Alert
} from "reactstrap";
import RoleServices from "../../services/RoleServices";
import UserServices from "../../services/UserServices";



const User = () => {
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [modal, setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [newUser, setNewUser] = useState({
        id: null,
        first_name: '',
        username: '',
        last_name: '',
        email: "",
        role_id: "",
        phone: "",
        password: "",
        confirmPassword: ""
    });
    const [editUser, setEditUser] = useState({
        id: null,
        first_name: '',
        username: '',
        last_name: '',
        email: "",
        role_id: "",
        phone: "",
        password: ""
    });
    const [deleteUser, setDeleteUser] = useState(null);

    useEffect(() => {
        UserServices.getUsers().then(data => {
            setUsers(data['data']);
        });

        RoleServices.getRoles().then(data => {
            setRoles(data['data']);
        });
    }, []);

    const isPasswordValid = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return regex.test(password);
    };

    const showRoleTitle = (roleId) => {
        const role = roles.filter((r) => r.id === roleId);
        let element;
        if (typeof role[0] !== 'undefined') {
            element = role[0];
        } else {
            element = {
                title: " "
            }
        }
        return element.title;
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const toggleEditModal = () => {
        setEditModal(!editModal);
    };

    const toggleDeleteModal = () => {
        setDeleteModal(!deleteModal);
    };

    const handleNewUserChange = (event) => {
        setNewUser({ ...newUser, [event.target.name]: event.target.value });
    };

    const handleEditUserChange = (event) => {
        setEditUser({ ...editUser, [event.target.name]: event.target.value });
    };

    const phoneRegex = /^\d+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateFields = () => {
        if (
            newUser.first_name.trim() === "" ||
            newUser.last_name.trim() === "" ||
            newUser.username.trim() === "" ||
            newUser.email.trim() === "" ||
            newUser.phone.trim() === ""
        ) {
            setAlert("Veuillez remplir tous les champs obligatoires.");
            return false;
        }

        if (newUser.phone.length !== 8) {
            setAlert("Le numéro de téléphone doit avoir une longueur de 8 caractères.");
            return false;
        }

        if (!phoneRegex.test(newUser.phone)) {
            setAlert("Le numéro de téléphone ne doit contenir que des chiffres.");
            return false;
        }

        if (!emailRegex.test(newUser.email)) {
            setAlert("Veuillez entrer une adresse email valide.");
            return false;
        }

        if (!isPasswordValid(newUser.password)) {
            setMessage("");
            setAlert(
                "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un nombre, un caractère spécial et avoir une longueur minimale de 8 caractères."
            );
            return false;
        }

        return true;
    };

    const addUser = () => {
        UserServices.addUser({
            first_name: newUser.first_name,
            last_name: newUser.last_name,
            username: newUser.username,
            email: newUser.email,
            role_id: parseInt(newUser.role_id),
            phone: newUser.phone,
            password: newUser.password,
            created_by: parseInt(localStorage.getItem("created_by")),
        }).then((data) => console.log(data));

        setUsers([
            ...users,
            {
                id: users.length + 1,
                first_name: newUser.first_name,
                username: newUser.username,
                last_name: newUser.last_name,
                email: newUser.email,
                role_id: newUser.role_id,
                phone: newUser.phone,
                password: newUser.password,
                created_by: parseInt(localStorage.getItem("created_by")),
            },
        ]);

        setNewUser({
            id: null,
            first_name: "",
            username: "",
            last_name: "",
            email: "",
            role_id: "",
            phone: "",
            password: "",
            confirmPassword: "",
        });

        toggleModal();
        setMessage("Utilisateur ajouté avec succès !");
    };

    const handleAddUser = () => {
        if (newUser.password !== newUser.confirmPassword) {
            setAlert("Les mots de passe ne sont pas identiques.");
        } else {
            if (validateFields()) {
                addUser();
            }
        }
    };


    const handleEditUser = () => {
        const updatedUser = users.map((r) => {
            if (r.id === editUser.id) {
                return editUser;
            } else {
                return r;
            }
        });
        console.log(editUser);
        UserServices
            .updateUser(editUser)
            .then(data => console.log(data));
        setUsers(updatedUser);
        setEditUser({
            id: null,
            first_name: '',
            username: '',
            last_name: '',
            email: "",
            role_id: "",
            phone: "",
            password: ""
        });
        toggleEditModal();
    };

    const handleDeleteUser = () => {
        const updatedUser = users.filter((r) => r.id !== deleteUser.id);
        UserServices
            .deleteUser(deleteUser)
            .then(data => console.log(data));
        setUsers(updatedUser);
        setDeleteUser(null);
        toggleDeleteModal();
        setMessage("Utilisateur supprimé avec succès !")
    };

    return (
        <Container>
            <h1 className='mb-5'>Liste des utilisateurs</h1>
            {message && <Alert color="success">{message}</Alert>}
            <Button color="primary" className='mb-4' onClick={toggleModal}>
                Ajouter un utilisateur
            </Button>
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Prénom</th>
                        <th>Nom</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Rôle</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.first_name}</td>
                            <td>{user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            <td>{showRoleTitle(user.role_id)}</td>
                            <td>
                                <Button
                                    color="warning"
                                    onClick={() => {
                                        setEditUser(user);
                                        toggleEditModal();
                                    }}
                                >
                                    Modifier
                                </Button>


                                <Button
                                    color="danger"
                                    onClick={() => {
                                        setDeleteUser(user);
                                        toggleDeleteModal();
                                    }}
                                >
                                    Supprimer
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal isOpen={modal} toggle={toggleModal} className="modal-dialog modal-lg">
                <ModalHeader toggle={toggleModal}>Ajouter un utilisateur</ModalHeader>
                <ModalBody>
                    {alert && <Alert color="danger">{alert}</Alert>}
                    <Form>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="first_name">Prénom *</Label>
                                    <Input
                                        type="text"
                                        name="first_name"
                                        id="first_name"
                                        value={newUser.first_name || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="last_name">Nom *</Label>
                                    <Input
                                        type="text"
                                        name="last_name"
                                        id="last_name"
                                        value={newUser.last_name || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="username">Nomd'utilisateur *</Label>
                                    <Input
                                        type="text"
                                        name="username"
                                        id="username"
                                        value={newUser.username || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="email">Adresse e-mail *</Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={newUser.email || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="phone">Numéro de téléphone *</Label>
                                    <Input
                                        type="tel"
                                        name="phone"
                                        id="phone"
                                        value={newUser.phone || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="role_id">Rôle *</Label>
                                    <Input
                                        type="select"
                                        name="role_id"
                                        id="role_id"
                                        value={newUser.role_id || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    >
                                        <option value="">Sélectionnez un rôle</option>
                                        {roles.map(role => (
                                            <option key={role.id} value={role.id}>{role.title}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="password">Mot de passe *</Label>
                                    <Input
                                        type="password"
                                        name="password"
                                        id="password"
                                        value={newUser.password || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                        placeholder="Il faut 8 Caractères au minimum"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="confirmPassword">Confirmation mot de passe *</Label>
                                    <Input
                                        type="password"
                                        name="confirmPassword"
                                        id="confirmPassword"
                                        value={newUser.confirmPassword || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                        placeholder="Il faut 8 Caractères au minimum"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddUser}>
                        Ajouter
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={editModal} toggle={toggleEditModal} className="modal-dialog modal-lg">
                <ModalHeader toggle={toggleEditModal}>Modifier l'utilisateur</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="first_name">Prénom *</Label>
                                    <Input
                                        type="text"
                                        name="first_name"
                                        id="first_name"
                                        value={editUser.first_name || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="last_name">Nom *</Label>
                                    <Input
                                        type="text"
                                        name="last_name"
                                        id="last_name"
                                        value={editUser.last_name || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="email">Adresse e-mail *</Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={editUser.email || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="phone">Numéro de Téléphone *</Label>
                                    <Input
                                        type="tel"
                                        name="phone"
                                        id="phone"
                                        value={editUser.phone || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleEditUser}>
                        Modifier
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleEditModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
                <ModalHeader toggle={toggleDeleteModal}>Supprimer l'utilisateur</ModalHeader>
                <ModalBody>
                    Êtes-vous sûr de vouloir supprimer cet utilisateur ?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleDeleteUser}>
                        Supprimer
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleDeleteModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default User;
